<template>
  <span>EMPTY</span>
</template>

<script>
import Vue from "vue";

export default {
  props: ["forcepath", "myself"],
  data() {
    return {
      res: {},
      params: false,
      lazyload: false,
      loading: true,
      isEmbed: false
    };
  },
  components: {},
  methods: {
    onInit() {},
    onLoad() {},
    onError(err) {},

    async query(path, args) {
      this.loading = true;

      if (global.config.socketiopage_force === true) {
        args = args || {};
        args.websocket = this.$socket;
      }
      try {
        this.res = await global.express.meta(path, args);
      } catch (err) {
        this.onError(err);
      }
      this.onLoad();
      this.loading = false;
    },
    async callLocalAction(
      actionName,
      args = {},
      ondata = null,
      silent = false
    ) {
      if (!silent) this.loading = true;

      if (args == null) args = {};

      args = _.assignIn({}, args);

      if (global.config.socketiopage_force === true) {
        args = args || {};
        args.websocket = this.$socket;
      }

      args.actionName = actionName;
      let path = this.getMyPath();

      let $return = null;
      try {
        $return = await global.express.meta(path, args, ondata);
      } catch (e) {
        Vue.$toast.open({
          message: this.T(
            "Houve uma falha ao realizar a operação! Por favor tente novamente mais tarde!"
          ),
          type: "error"
        });
        throw e;
      }

      if (!silent) this.loading = false;
      return $return;
    },

    async querylazy(path, args) {
      this.loading = true;
      this.res = await global.express.metawait(path, args);
      this.onLoad();
      this.loading = false;
    },
    getMyPath() {
      let path = false;
      if (this.$vnode.componentOptions && this.$vnode.componentOptions.tag) {
        path = this.$vnode.componentOptions.tag.replace(/\-/g, "/");
        //console.log("PPP", path, this.forcepath);
        if (path.indexOf("pageloaded_") === 0 || this.forcepath) {
          path = this.forcepath;
        }
      } else {
        path = this.$route.name.replace(/\-/g, "/");
      }
      if (path.indexOf("adminpage/") === 0) path = path.substr(10);
      return path;
    },
    async refresh(paramadd = null) {
      this.onInit();
      if (this.params !== false && this.lazyload === false) {
        let path = this.getMyPath();

        await this.query(path, _.assignIn({}, this.params, paramadd));
      }
    }
  },
  async beforeMount() {
    this.onInit();
    if (this.params !== false && this.lazyload === false) {
      let path = this.getMyPath();
      await this.query(path, this.params);
    }
  },
  async mounted() {
    let path = false;
    if (this.$vnode.componentOptions && this.$vnode.componentOptions.tag) {
      path = this.$vnode.componentOptions.tag.replace(/\-/g, "/");
      if (path.indexOf("pageloaded_") === 0) {
        path = this.forcepath;
      }
    }
    if (this.lazyload !== false) {
      await this.querylazy(path, this.lazyload);
    }
  },
  watch: {
    "$route.params": function(path) {
      if (!this.isEmbed) {
        console.log(this.$route);
        this.refresh();
      }
    }
  }
};
</script>

<style scoped></style>
